import ISPyB from '../config/config.js';


export function getJobTypes(category, target) {
    var url =   ISPyB.sites[0].dataAnalysis.url + '/jobs/type/category/target'
        .replace("category", category)
        .replace("target", target);  
    return url;
}

export function getJobsByUsername(username) {
    return ISPyB.sites[0].dataAnalysis.url + '/jobs/' + username;
}

export function getUpload() {
    return ISPyB.sites[0].dataAnalysis.url + '/upload';
}


export function getDownload(id) {
    return ISPyB.sites[0].dataAnalysis.url + '/' +  id+ '/download';
}



// WEBPACK FOOTER //
// ./src/api/is4a.js